import axios from 'axios'
import library from '../../../utils/Library'

export const getUserOrganizationByLoginAccountCorpEntities = async (
  loginAccountId
) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('organization') +
    '/getUserOrganizationByLoginAccountCorpEntities'

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: {
      loginAccountId: loginAccountId
    }
  })
}
